import axios from 'axios';
import router from '@/routes';
import swal from 'sweetalert2';

const _customAxios = axios.create({
    baseURL: process.env.VUE_APP_BACKEND_URL,
});

let _isRefreshing = false;
let _refreshQueue = [];

const _processQueue = (error, token = null) => {
    _refreshQueue.forEach(({ resolve, reject }) => error ? reject(error) : resolve(token));
    _refreshQueue = [];
};

_customAxios.interceptors.response.use(
    (response) => response,
    async (error) => {
        const original = error.config;

        const isExpired =
            error.response?.status === 401 &&
            error.response?.data?.detail === 'Token expirado' &&
            !original._retry;

        if (!isExpired) return Promise.reject(error);

        if (_isRefreshing) {
            return new Promise((resolve, reject) => {
                _refreshQueue.push({ resolve, reject });
            }).then((token) => {
                original.headers['Authorization'] = `Bearer ${token}`;
                return _customAxios(original);
            });
        }

        original._retry = true;
        _isRefreshing = true;

        try {
            const { data } = await axios.post(
                `${process.env.VUE_APP_BACKEND_URL}/users/clients/refresh`,
                null,
                { withCredentials: true }
            );

            const newToken = data?.data?.access_token;
            if (!newToken) throw new Error('no token');

            const store = (await import('@/state')).default;
            store.commit('users/SET_ACCESS_TOKEN', newToken);

            _processQueue(null, newToken);
            original.headers['Authorization'] = `Bearer ${newToken}`;
            return _customAxios(original);
        } catch (refreshError) {
            _processQueue(refreshError);

            const store = (await import('@/state')).default;
            store.dispatch('users/logout');

            await swal({
                title: 'Sessão Expirada',
                text: 'Faça login novamente para continuar',
                icon: 'warning',
                confirmButtonText: 'OK',
                allowOutsideClick: false,
            });

            router.push({ name: 'login' });

            return Promise.reject(refreshError);
        } finally {
            _isRefreshing = false;
        }
    }
);

export default _customAxios;
